import { AxiosResponse } from "axios";
import axiosInstance from "../../../../interceptors/axiosInstance";
import { Filtros, RespuestaInformeCMFDTO, GetNameFileResponseDto } from "../models/informeCMF";
import { ListResponseDto } from "../../../../dtos/ListResponseDto";

const getInformesCMF = async (data: Filtros) => {
    const response: AxiosResponse<ListResponseDto<RespuestaInformeCMFDTO>> = await axiosInstance.get('siscred-api-reportes/v1/informes-cmf/listar', {
        params: data,
    });
    return response;
};

const getNameInformeCMF = async (data: Filtros) => {
    const response: AxiosResponse<GetNameFileResponseDto> = await axiosInstance.get('siscred-api-reportes/v1/informes-cmf/get-name', {
        params: data,
    });
    return response;
};

export {
    getInformesCMF,
    getNameInformeCMF
}